import React, { memo } from "react";
import PropTypes from "prop-types";

const SettlementNote = ({ bgColor }) => (
  <section style={{ backgroundColor: bgColor }} className="w-full py-[12px]">
    <div className="container py-[12px]">
      <p className="font-normal italic text-[12px] text-cf-faded-black">
        * Settlement cycle is subject to bank approval and can vary based on
        transaction type, business category/model, risk parameters and other
        factors.
      </p>
    </div>
  </section>
);

SettlementNote.defaultProps = {
  bgColor: "#F6F6FF",
};

SettlementNote.propTypes = {
  bgColor: PropTypes.string,
};

export default memo(SettlementNote);
